import Bugsnag from '@bugsnag/js';

export const notifyErrorToBugsnag = (state: any, action: any) => {
  Bugsnag.notify(
    {
      name: action?.type,
      errorClass: action?.error?.code,
      errorMessage: action?.error?.message,
      message: action?.error?.message || '',
      cause: action?.error?.stack,
    },
    (event) => event.addMetadata('state', state),
  );
};
